<nb-layout>
  <nb-layout-column class="login">
    <div class="col-xl-4 col-lg-6 col-md-6 col-sm-6 mx-auto">
      <router-outlet></router-outlet>
    </div>
  </nb-layout-column>
</nb-layout>